import {FC} from 'react';

import NavLink from '~/common/NavLink/NavLink';
import {Icons} from '~/common/Icon';
import CardBordered from '~/common/display/CardBordered/CardBordered';

import s from '../styles.module.scss';

const MyHotlinksPageLink: FC<any> = ({onClickBack}) => {
  return (
    <CardBordered className={s.card}>
      <NavLink icon={Icons.myHotlinks} label="My Hotlink Page" carretLeft onClick={onClickBack} />
      <NavLink icon={Icons.editHotlinksPage} label="Edit Hotlink Page" asChild />
      <NavLink icon={Icons.subscribers} label="Subscribers" asChild />
    </CardBordered>
  );
};

export default MyHotlinksPageLink;
